import { call, put } from 'redux-saga/effects';
import CouponsService from 'services/couponsService';
import FileService from 'services/fileservice';
import StoreCategoriesService from 'services/storeCategoriesService';
import { createAndDownloadFile } from 'utils/functions/generals';
import {
  loadFile,
  loadFileFailure,
  loadFileSuccess,
} from '../generals/file/actions';
import { loadCategoryFailure, loadCategorySuccess } from './actions';

export function* loadCategoriesSaga(action: any) {
  try {
    const { data, total } = yield call(
      StoreCategoriesService.getAllCategories,
      action.payload.query,
    );
    yield put(loadCategorySuccess({ total, data }));
  } catch (err) {
    yield put(loadCategoryFailure());
  }
}

export function* loadCategoryFileSaga(action: any) {
  try {
    yield put(loadFile());
    const file = yield call(
      FileService.getFile,
      action.payload.query,
      action.payload.rootPath,
    );
    if (file?.response?.status) {
      yield put(loadFileFailure());
    } else {
      yield put(loadFileSuccess());
      createAndDownloadFile(file, 'Categorias.xls');
    }
  } catch (error) {
    yield put(loadFileFailure());
  }
}
